<template>
  <section class="hero is-white">
    <div class="hero-body">
      <div class="breadcrumb-wrapper">
        <img src="@/assets/images/icons/icon-home.png" alt class="icon-home" />
        <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
          <ul>
            <li>
              <router-link to="/index">Trang chủ</router-link>
            </li>
            <li class="is-active">
              <a>Admin</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="container">
        <admin-menu :activeLink="'/party-management'" />
        <h2 class="title is-4 has-text-centered">Danh sách user</h2>
        <div class="columns is-mobile">
          <div class="column content-management">
            <div
              :class="`${showModalAddUser ? 'is-active' : ''}`"
              class="modal"
              id="modal-bis">
              <div @click="showModalAddUser = false" class="modal-background"/>
              <div class="modal-content">
                <div class="modal-content__add">
                  <user-add
                    :currentUser="currentUser"
                    :is-parent-show-add-user="showModalAddUser"
                    @hide-modal="showModalAddUser = $event"/>
                </div>
              </div>
              <button
                aria-label="close"
                class="modal-close is-large"
                @click="showModalAddUser = false"/>
            </div>
            <div style="margin-left: 15px;">
              <download-csv
                :data="dataExport"
                class="btn-download"
                v-if="!isLoadingParticipants">
                  Danh sách tất cả participant
              </download-csv>
              <div class="button is-loading" v-else/>
            </div>
            <div class="mt-20 mb-20">
              <autocomplete
                :items="accountsSearch.map(({username}) => username)"
                :label="'Lọc theo tài khoản'"
                @input="filterByKeyword"/>
            </div>
            <div class="columns">
              <div class="userlist column">
                <div class="field is-grouped userlist__button">
                  <div class="control">
                    <b-button type="is-info" @click="setUserStatus">{{getUserStatusText}}</b-button>
                  </div>
                  <div class="control">
                    <b-button type="is-danger" @click="openDeleteModal">Xoá 1 người dùng</b-button>
                  </div>
                  <div class="control">
                    <b-button type="is-info" @click="openUpdatePassModal">Thay đổi mật khẩu</b-button>
                  </div>
                </div>
                <div class="user-list-count">
                  <div
                    class="has-text-weight-bold"
                  >Có {{participants&&participants.length}} người dùng</div>
                </div>
                <section>
                  <div>
                    <div
                      :class="{ 'checked': list.key === computedSelectedAlphabet }"
                      :key="list.key"
                      @click="scrollElement({ key: list.key, id: list.id })"
                      class="user-link"
                      v-for="list in alphabetAccount">
                      <div>{{list.key}}</div>
                    </div>
                  </div>
                  <b-table
                    :data="participantsWithKeyword"
                    :paginated="false"
                    :sort-icon-size="'is-small'"
                    :sticky-header="true"
                    class="table is-fullwidth table-party-management"
                    default-sort="name"
                    ref="multiSortTable"
                    v-if="participantsWithKeyword">
                      <template slot-scope="props">
                        <b-table-column
                          :class="{'bg-grey': props.row.disabled === 'true'}"
                          label="STT" width="70">
                          {{props.index+1}}
                        </b-table-column>
                        <b-table-column
                          :class="{'bg-grey': props.row.disabled === 'true'}"
                          :ref="props.row.entityTag"
                          field="name"
                          label="Tài khoản"
                          sortable>
                            <b-radio
                              :native-value="props.row"
                              v-model="selectedUser"
                              class="color-primary-2"
                              type="is-info"/>
                                <span class="icon-user-book" v-if="props.row.disabled === 'false'">
                                  <img src="@/assets/images/icons/icon-user.png" alt />
                                </span>
                                <span class="icon-user-book" v-else>
                                  <img src="@/assets/images/icons/icon-user_disabled.png" alt />
                                </span>
                            {{props.row.name}}
                        </b-table-column>
                        <b-table-column
                          :class="{'bg-grey': props.row.disabled === 'true'}"
                          field="firstName"
                          label="Tên"
                          sortable>
                            {{props.row.firstName}}
                        </b-table-column>
                        <b-table-column
                          :class="{'bg-grey': props.row.disabled === 'true'}"
                          field="email"
                          label="Email"
                          sortable>
                            {{props.row.email}}
                        </b-table-column>
                      </template>
                  </b-table>
                </section>
                <div v-if="!totalOrderedUser" class="has-text-centered mt-40">Không có kết quả</div>
                <b-modal :active.sync="isOpenUpdatePassModal">
                  <div class="content-layout content-layout--passcode">
                    <header class="modal-card-head">
                      <p
                        class="modal-card-title"
                      >Thay đổi mật khẩu {{this.selectedUser && this.selectedUser.name}}</p>
                      <button
                        aria-label="close"
                        class="delete"
                        @click="isOpenUpdatePassModal=false"
                      />
                    </header>
                    <form @submit.prevent="validatePassword">
                      <div class="content-layout__inner">
                        <div class="form-user">
                          <b-field
                            :type="{'is-danger': errors.has('password')}"
                            :message="errors.first('password')"
                            custom-class="has-text-weight-normal body-text"
                          >
                            <template slot="label">
                              Mật khẩu
                              <span class="has-text-danger">*</span>
                            </template>
                            <b-input
                              v-model="password"
                              type="password"
                              name="password"
                              v-validate="{required: true, regex: /\w/, min: 8}"
                              size="is-medium"
                              ref="updatePassword"
                              data-vv-as="Mật khẩu"
                            />
                          </b-field>

                          <b-field
                            :type="{'is-danger': errors.has('confirm-password')}"
                            :message="errors.first('confirm-password')"
                            custom-class="has-text-weight-normal body-text"
                          >
                            <template slot="label">
                              Xác nhận mật khẩu
                              <span class="has-text-danger">*</span>
                            </template>
                            <b-input
                              v-model="confirmPassword"
                              v-validate="{ required: true, is: password }"
                              type="password"
                              name="confirm-password"
                              size="is-medium"
                              data-vv-as="Xác nhận mật khẩu"
                            />
                          </b-field>
                        </div>
                      </div>
                      <div class="modal-bottom-group field is-grouped is-grouped-centered">
                        <div class="control">
                          <b-button @click="isOpenUpdatePassModal=false">Đóng</b-button>
                        </div>
                        <div class="control">
                          <b-button type="is-info" native-type="submit">Thay đổi</b-button>
                        </div>
                      </div>
                    </form>
                  </div>
                </b-modal>
                <b-modal :active.sync="isDeleteUserModal">
                  <div class="content-layout content-layout--passcode">
                    <header class="modal-card-head">
                      <p
                        class="modal-card-title"
                      >Xoá participant {{this.selectedUser && this.selectedUser.name}}</p>
                      <button aria-label="close" class="delete" @click="isDeleteUserModal=false" />
                    </header>
                    <div class="content-layout__inner">
                      <div class="body-text">Xin xác nhận xoá participant?</div>
                    </div>
                    <div class="modal-bottom-group field is-grouped is-grouped-centered">
                      <div class="control">
                        <b-button @click="isDeleteUserModal=false">Đóng</b-button>
                      </div>
                      <div class="control">
                        <b-button type="is-danger" @click="deleteUser">Xoá</b-button>
                      </div>
                    </div>
                  </div>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import { mapState, mapActions, mapMutations } from "vuex";
import JsonCSV from 'vue-json-csv'

import Utils from '@/components/shared/Utils'

Vue.component('downloadCsv', JsonCSV)
export default {
  components: {
    AdminMenu: () => import("./AdminMenu"),
    Autocomplete: () => import("../shared/Autocomplete"),
    UserAdd: () => import("../DashBoard/UserAdd"),
  },
  computed: {
    ...mapState("hostAccount", ["accounts"]),
    accountsSearch() {
      return this.accounts || [];
    },
    alphabetAccount() {
      const list = this.participantsWithKeyword.map(acc => {
        return {
          name: acc.name,
          id: acc.entityTag,
        }
      })
      return Utils.createAlphabetList(list)
    },
    computedSelectedAlphabet() {
      if(this.selectedAlphabet) {
        return this.selectedAlphabet
      }
      return this.alphabetAccount[0].key
    },
    currentUser() {
      return this.username;
    },
    dataExport() {
      const data = [];
      if(!this.participants) return [];
      this.participants.map(item => {
        data.push({
          "Tài khoản": item.name,
          "Tên": item.firstName,
          "Trạng thái Khoá": item.locked,
          "Trạng thái Kích Hoạt": item.disabled,
          "Email": item.email,
          "Người quản lý": item.owner
        }) 
      })
      return data;
    },
    getUserStatusText() {
      return this.selectedUser&&this.selectedUser.disabled === "true"
        ? "Kích hoạt người dùng"
        : "Vô hiệu hoá người dùng";
    },
    participantsWithKeyword() {
      return this.participants&&this.participants.filter(user => {
        return user.name.includes(this.keyword)
      })||[]
    },
    totalOrderedUser() {
      return this.participants&&this.participants.length
    },
  },
  created() {
    this.isLoadingParticipants = true
    this.fetchAccountList()
    .then(() => {
      this.getAllParticipants(this.accounts)
      .then(participants => {
        this.participants = participants.data.map(user => {
        const newUser = { ...user }
        for (const key of Object.keys(newUser)) {
          newUser[key] = newUser[key][0]
        }
        return newUser;
      });
      }).finally(() => {
        this.isLoadingParticipants = false
      })
    });
  },
  data() {
    return {
      confirmPassword: "",
      isOpenUpdatePassModal: false,
      isDeleteUserModal: false,
      isDeleteMultiUserModal: false,
      isConfirmDeleteMultiUserModal: false,
      isLoadingParticipants: false,
      keyword: "",
      keywordPartyName: "",
      keywordRemovableParticipant: "",
      lastSelectedParticipants: [],
      password: "",
      participants: null,
      selectedAlphabet: null,
      selectedAlphabetByAdmin: null,
      selectedParticipants: [],
      selectedUser: null,
      showModalAddUser: false,
    };
  },
  methods: {
    ...mapActions("hostAccount",
      ["disableParticipantWithOwner", "deleteParticipantsByAdmin",
        "fetchAccountList",
        "getAllParticipants", "getParticipantsWithUsername",
        "searchParties"]),
    ...mapActions("participant", ["changePassword", "deleteParticipant"]),
    ...mapMutations("hostAccount", ["resetParticipantListAtAdmin"]),
    deleteUser() {
      const { name, owner } = this.selectedUser

      this.deleteParticipant({ name, owner })
      .then(res => {
        let message = "";
        if (res.data.status) {
          message = "Xoá người dùng thành công!"
          this.selectedUser = null
            setTimeout(function() {
              location.reload();
            }, 1000);
        } else {
          message = "Lỗi máy chủ!!"
        }
        this.$toast.open({
          message,
          type: "is-info"
        });
      })
      .finally(() => {
        this.isDeleteUserModal = false
      })
    },
    filterByKeyword(keyword) {
      this.keyword = keyword;
    },
    openDeleteModal() {
      if(!this.selectedUser) return
      this.isDeleteUserModal = true
    },
    openUpdatePassModal() {
      if(!this.selectedUser) return
      this.isOpenUpdatePassModal = true;
      this.$nextTick(() => {
        this.$refs.updatePassword.$el.querySelector("input").focus();
      });
    },
    scrollElement(evt) {
      this.$refs.multiSortTable.initSort()
      this.$nextTick(() => {
        if(this.alphabetAccount.length) {
          this.selectedAlphabet = evt.key
          this.$refs.multiSortTable.$el.querySelector('.table-wrapper').scrollTop = this.$refs[evt.id].$el.offsetTop - 75
        }
      })
    },
    searchPartiesUI() {
      this.searchParties({
        owner: this.username,
        searchName: Utils.latinify(this.keywordPartyName)
      });
    },
    selectParty(data) {
      this.lastSelectedParticipants = [
        ...this.lastSelectedParticipants.map(user => {
          if (user.name === data.name) {
            user.checked = !user.checked;
          }
          return user;
        })
      ];
    },
    setUserStatus() {
      if(!this.selectedUser) return
      const user = { ...this.selectedUser }
      user.disabled = user.disabled.toLowerCase() === "true" ? "false" : "true"
      this.disableParticipantWithOwner({
        user,
        userOwner: this.selectedUser.owner
      })
      .then(() => {
        const index = this.participants.findIndex(
          user => user.name === this.selectedUser.name
        );
        if(index > -1) {
          this.$set(this.participants, index, user)
        }
      })
    },
    updatePassWord() {
      const password = this.password;
      const user = { ...this.selectedUser, password };
      this.changePassword(user).then(() => {
        let message = "Thay đổi mật khẩu thành công!";
        this.isOpenUpdatePassModal = false;
        this.$toast.open({
          message,
          type: "is-info"
        });
      });
    },
    validatePassword() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updatePassWord();
        }
      });
    },
  },
  watch: {
    participants() {
      if (this.participants) {
        this.selectedParticipants = this.participants && [
          ...this.participants
            .map(user => {
              const data = user;
              data.checked = false;
              return data;
            })
            .sort((user1, user2) => {
              return user1.name < user2.name ? -1 : 1;
            })
        ];
      }
    },
    selectedParticipants() {
      this.lastSelectedParticipants = [...this.selectedParticipants];
    }
  }
};
</script>

<style lang="scss">
.userlist__button {
  margin-left: 15px;
}
.userlist {
  &__icon {
    vertical-align: text-top;
    margin-right: 1rem;
  }
  &__table {
    overflow-x: scroll;
  }
}
.add-user-block {
  margin-left: 30px;
  &:hover {
    opacity: 0.8;
  }
  display: flex;
  span {
    svg {
      width: 3rem;
      height: 3rem;
    }
  }
}
.txt-add {
  font-size: 1.2rem;
  margin-left: 10px;
}

.modal-content__add {
  padding: 1rem;
}
.modal-close {
  height: 64px !important;
  max-height: 64px !important;
  max-width: 64px !important;
  min-height: 64px !important;
  min-width: 64px !important;
  width: 64px !important;
}
.radio-button {
  width: 30px;
}
.icon-user-book {
  display: inline-block;
  width: 30px;
  vertical-align: middle;
  margin-right: 15px;
}
.userlist__table {
  &.table td {
    vertical-align: middle;
    border: 0;
  }
}
.radio {
  vertical-align: middle;
}
.middle-text {
  display: inline-block;
  vertical-align: middle;
}
.columns.is-gapless > .column:first-child {
  padding-left: 15px !important;
  &.account {
    padding-left: 25px !important;
  }
}
.user-alphabet {
  padding: 10px 90px;
  background-color: #f8f8f8;
}
.columns {
  padding: 5px 0;
}
.userlist__wrapper {
  max-height: 300px;
  overflow-y: auto;
}
.user-list-key,
.user-list-count {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 30px;
}
.user-link {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #14afb4;

  &.checked {
    background-color: #14afb4;
    border-radius: 50%;
    color: #fff;
  }
}
.field-search-party .input {
  width: 270px;
  height: 32px;
}

.columns.is-gapless:not(:last-child) {
  &.colums--no-margin {
    margin-bottom: 0;
  }
}
.userlist__heading {
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid #dbdbdb;
}
.field-label {
  .label--filter-party {
    font-size: 1.2rem;
    font-weight: 400;
  }
}
.order {
  flex: 0 0 90px;
}
.right-control {
  margin-right: 30px;
}
.table-party-management .table-wrapper {
  height: 500px;
  overflow-y: auto;
}
.table-party-management th {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
}
.vvc-field-label__search__model {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.label--delete-party {
  font-size: 14px;
  color: inherit;
  font-weight: 400;
}
.vvc-party-count {
  padding: 0 10px;
}
</style>